import { render, staticRenderFns } from "./MubadalaForCustomerDetail.vue?vue&type=template&id=16c97f14&scoped=true&"
import script from "./MubadalaForCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./MubadalaForCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./MubadalaForCustomerDetail.vue?vue&type=style&index=0&id=16c97f14&scoped=true&lang=css&"
import style1 from "./MubadalaForCustomerDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c97f14",
  null
  
)

export default component.exports